import gql from 'graphql-tag';
import actionTypes from './constants';

/* */
export const getBrand = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_BRAND}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => data.payboxGetBrand);

/* */
export const capture = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.CAPTURE}`,
  variables,
})
  .then(({ data }) => data.payboxCapture);

/* */
export const captureSubscriber = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.CAPTURE_SUBSCRIBER}`,
  variables,
})
  .then(({ data }) => data.payboxCaptureSubscriber);

/* */
export const createSubscriber = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.SUBSCRIBE}`,
  variables,
})
  .then(({ data }) => data.payboxSubscribe);

/* */
export const subscribeAndCapture = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.SUBSCRIBE_AND_CAPTURE}`,
  variables,
})
  .then(({ data }) => data.payboxSubscribeAndCapture);
